export default {
    okText: '确定',
    cancelText: '取消',
};



// WEBPACK FOOTER //
// ./components/menu/locale/zh_CN.tsx